// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Common = require("../utils/Common.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var MM_cmp_pe_stmt = require("./MM_cmp_pe_stmt.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.res.js");
var JsxPPXReactSupportU = require("rescript/lib/js/jsxPPXReactSupportU.js");
var Divider = require("@mui/material/Divider").default;
var MM_cmp_pe_frame_descr = require("./MM_cmp_pe_frame_descr.res.js");
var MM_cmp_pe_frame_summary_state = require("./MM_cmp_pe_frame_summary_state.res.js");

var paddingLeft = "5px";

function propsAreSame(a, b) {
  if (a.typeColors === b.typeColors && a.editStmtsByLeftClick === b.editStmtsByLeftClick && a.typeOrderInDisj === b.typeOrderInDisj && a.settings === b.settings && a.preCtx === b.preCtx && a.symColors === b.symColors && a.frame === b.frame && a.order === b.order && a.matchedIdxs === b.matchedIdxs) {
    return a.highlightColor === b.highlightColor;
  } else {
    return false;
  }
}

var make = React.memo((function (param) {
        var addAsrtByLabel = param.addAsrtByLabel;
        var openExplorer = param.openExplorer;
        var openFrameExplorer = param.openFrameExplorer;
        var highlightColor = param.highlightColor;
        var matchedIdxs = param.matchedIdxs;
        var order = param.order;
        var frame = param.frame;
        var parenCnt = param.parenCnt;
        var frms = param.frms;
        var syntaxTypes = param.syntaxTypes;
        var symColors = param.symColors;
        var preCtx = param.preCtx;
        var settings = param.settings;
        var typeOrderInDisj = param.typeOrderInDisj;
        var editStmtsByLeftClick = param.editStmtsByLeftClick;
        var typeColors = param.typeColors;
        var modalRef = param.modalRef;
        var match = React.useState(function () {
              return MM_cmp_pe_frame_summary_state.makeInitialState(preCtx, frame, typeColors, typeOrderInDisj);
            });
        var setState = match[1];
        var state = match[0];
        var match$1 = React.useState(function () {
              
            });
        var setAsrtWasAddedToEditor = match$1[1];
        var asrtWasAddedToEditor = match$1[0];
        React.useEffect((function () {
                setState(function (param) {
                      return MM_cmp_pe_frame_summary_state.makeInitialState(preCtx, frame, typeColors, typeOrderInDisj);
                    });
              }), [
              typeColors,
              editStmtsByLeftClick,
              typeOrderInDisj,
              preCtx,
              frame,
              order
            ]);
        var actToggleDescrIsExpanded = function () {
          setState(MM_cmp_pe_frame_summary_state.toggleDescrIsExpanded);
        };
        var rndExpBtn = function () {
          if (Core__Option.isSome(frame.descr)) {
            return React.createElement("span", undefined, Common.nbsp + Common.nbsp, React.createElement("span", {
                            style: {
                              color: "grey",
                              cursor: "pointer",
                              fontFamily: "monospace"
                            },
                            onClick: MM_react_common.clickHnd(undefined, undefined, undefined, undefined, actToggleDescrIsExpanded)
                          }, "descr"), React.createElement("span", {
                            style: {
                              color: "grey",
                              cursor: "pointer",
                              display: "inline-block",
                              fontFamily: "monospace",
                              transform: state.descrIsExpanded ? "rotate(90deg) translate(1px, -2px)" : "none"
                            },
                            onClick: MM_react_common.clickHnd(undefined, undefined, undefined, undefined, actToggleDescrIsExpanded)
                          }, ">"));
          } else {
            return React.createElement(React.Fragment, {});
          }
        };
        var rndUseBtn = function () {
          if (addAsrtByLabel === undefined) {
            return null;
          }
          var tmp;
          if (asrtWasAddedToEditor !== undefined) {
            var msg = asrtWasAddedToEditor[0];
            tmp = msg.TAG === "Ok" ? React.createElement("span", {
                    style: {
                      color: "black",
                      fontFamily: "monospace"
                    }
                  }, Common.nbsp + "Added to the editor") : React.createElement("span", {
                    style: {
                      color: "red",
                      fontFamily: "monospace"
                    }
                  }, Common.nbsp + "Error: " + msg._0);
          } else {
            tmp = null;
          }
          return React.createElement("span", undefined, Common.nbsp + Common.nbsp, React.createElement("span", {
                          style: {
                            color: "grey",
                            cursor: "pointer",
                            fontFamily: "monospace"
                          },
                          onClick: MM_react_common.clickHnd(undefined, undefined, undefined, undefined, (function () {
                                  var label = frame.label;
                                  if (addAsrtByLabel !== undefined) {
                                    Expln_utils_promise.promiseMap(addAsrtByLabel(label), (function (res) {
                                            setAsrtWasAddedToEditor(function (msgAndTimerId) {
                                                  if (msgAndTimerId !== undefined) {
                                                    clearTimeout(msgAndTimerId[1]);
                                                  }
                                                  return [
                                                          res,
                                                          setTimeout((function () {
                                                                  setAsrtWasAddedToEditor(function (param) {
                                                                        
                                                                      });
                                                                }), 5000)
                                                        ];
                                                });
                                          }));
                                    return ;
                                  }
                                  
                                }))
                        }, "use"), tmp);
        };
        var rndLabel = function () {
          var asrtType = frame.isAxiom ? React.createElement("span", {
                  style: {
                    color: "red"
                  }
                }, "Axiom") : React.createElement("span", {
                  style: {
                    color: "green"
                  }
                }, "Theorem");
          var tmp = {
            fontWeight: "bold",
            borderRadius: "3px"
          };
          var tmp$1 = MM_react_common.getFrmLabelBkgColor(frame, settings);
          if (tmp$1 !== undefined) {
            tmp.backgroundColor = tmp$1;
          }
          return React.createElement("span", {
                      style: {
                        paddingRight: paddingLeft,
                        paddingLeft: paddingLeft
                      }
                    }, React.createElement("span", {
                          style: {
                            cursor: Core__Option.isSome(openFrameExplorer) ? "pointer" : "default"
                          },
                          onClick: MM_react_common.clickHnd(undefined, undefined, undefined, undefined, (function () {
                                  Core__Option.forEach(openFrameExplorer, (function (fn) {
                                          fn(frame.label);
                                        }));
                                }))
                        }, Core__Option.mapOr(order, "", (function (__x) {
                                return String(__x);
                              })) + " ", asrtType, " ", React.createElement("span", {
                              style: tmp
                            }, frame.label)), rndExpBtn(), rndUseBtn());
        };
        var rndDescr = function () {
          if (Belt_Option.isSome(frame.descr) && state.descrIsExpanded) {
            return React.createElement(React.Fragment, {}, React.createElement(Divider, {}), React.createElement("div", {
                            style: {
                              paddingRight: paddingLeft,
                              paddingLeft: paddingLeft
                            }
                          }, React.createElement(MM_cmp_pe_frame_descr.make, {
                                settings: settings,
                                ctx: preCtx,
                                symColors: symColors,
                                openFrameExplorer: (function (label) {
                                    Core__Option.forEach(openFrameExplorer, (function (func) {
                                            func(label);
                                          }));
                                  }),
                                text: Belt_Option.getWithDefault(frame.descr, "This " + (
                                      frame.isAxiom ? "axiom" : "theorem"
                                    ) + " doesn't have a description.")
                              })));
          } else {
            return React.createElement(React.Fragment, {});
          }
        };
        var rndUsageCnt = function () {
          if (state.descrIsExpanded) {
            return React.createElement(React.Fragment, {}, React.createElement(Divider, {}), React.createElement("span", {
                            style: {
                              paddingRight: paddingLeft,
                              paddingLeft: paddingLeft
                            }
                          }, "Referenced by: ", React.createElement("a", {
                                style: {
                                  color: "blue",
                                  cursor: "pointer",
                                  textDecoration: "underline"
                                },
                                onClick: (function (param) {
                                    Core__Option.forEach(openExplorer, (function (fn) {
                                            fn("Dependents of " + frame.label, undefined, undefined, frame.label, undefined, undefined);
                                          }));
                                  })
                              }, frame.usageCnt.toString())));
          } else {
            return React.createElement(React.Fragment, {});
          }
        };
        var rndDisj = function () {
          var disj = state.disj;
          if (disj !== undefined) {
            return React.createElement(React.Fragment, {}, React.createElement(Divider, {}), React.createElement("span", {
                            style: {
                              paddingRight: paddingLeft,
                              paddingLeft: paddingLeft
                            }
                          }, "Disj:" + MM_cmp_pe_frame_summary_state.disjGrpDelim, MM_cmp_pe_frame_summary_state.rndDisj(disj)));
          } else {
            return React.createElement("span", {
                        style: {
                          display: "none"
                        }
                      });
          }
        };
        var rndHyps = function () {
          if (state.eHyps.length === 0) {
            return React.createElement(React.Fragment, {});
          } else {
            return state.eHyps.map(function (hyp, i) {
                        return JsxPPXReactSupportU.createElementVariadicWithKey(String(i), React.Fragment, {
                                    children: null
                                  }, [
                                    React.createElement(Divider, {}),
                                    React.createElement("table", {
                                          style: {
                                            paddingRight: paddingLeft,
                                            paddingLeft: paddingLeft
                                          }
                                        }, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", {
                                                      style: {
                                                        verticalAlign: "top"
                                                      }
                                                    }, React.createElement("span", {
                                                          style: {
                                                            marginLeft: "10px"
                                                          }
                                                        }, Common.circleChar)), React.createElement("td", undefined, React.createElement(MM_cmp_pe_stmt.make, {
                                                          modalRef: modalRef,
                                                          ctx: state.frmCtx,
                                                          syntaxTypes: syntaxTypes,
                                                          frms: frms,
                                                          frameRestrict: settings.allowedFrms.inSyntax,
                                                          parenCnt: parenCnt,
                                                          stmt: hyp,
                                                          symColors: state.symColors,
                                                          symRename: state.symRename,
                                                          symsToHighlight: Core__Option.flatMap(matchedIdxs, (function (idxs) {
                                                                  return idxs[i];
                                                                })),
                                                          highlightColor: highlightColor,
                                                          editStmtsByLeftClick: editStmtsByLeftClick,
                                                          openExplorer: openExplorer
                                                        })))))
                                  ]);
                      });
          }
        };
        var rndAsrt = function () {
          return React.createElement("div", {
                      style: {
                        paddingRight: paddingLeft,
                        paddingLeft: paddingLeft
                      }
                    }, React.createElement(MM_cmp_pe_stmt.make, {
                          modalRef: modalRef,
                          ctx: state.frmCtx,
                          syntaxTypes: syntaxTypes,
                          frms: frms,
                          frameRestrict: settings.allowedFrms.inSyntax,
                          parenCnt: parenCnt,
                          stmt: state.asrt,
                          symColors: state.symColors,
                          symRename: state.symRename,
                          symsToHighlight: Core__Option.flatMap(matchedIdxs, (function (idxs) {
                                  return idxs[idxs.length - 1 | 0];
                                })),
                          highlightColor: highlightColor,
                          editStmtsByLeftClick: editStmtsByLeftClick,
                          openExplorer: openExplorer
                        }));
        };
        return React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, React.createElement(Paper, {
                                    elevation: 3,
                                    style: {
                                      backgroundColor: "rgb(255,255,235)"
                                    },
                                    children: Caml_option.some(null)
                                  }, rndLabel(), rndDescr(), rndUsageCnt(), rndDisj(), rndHyps(), React.createElement(Divider, {}), rndAsrt())))));
      }), propsAreSame);

var paddingRight = paddingLeft;

exports.paddingLeft = paddingLeft;
exports.paddingRight = paddingRight;
exports.propsAreSame = propsAreSame;
exports.make = make;
/* make Not a pure module */
